export class GerarDoc {

  Id: number;
  Nome: string;
  Extensao: string;
  ArquivoMasculino: File;
  ArquivoFeminino: File;
  constructor() {
    this.Id = 0;
    this.Nome = '';
  }
}
